import React from "react";
import StdPayment from "../../components/StudentTabs/StudentPayment/StdPayment";


const Payment = () => {
  return (
    <div>
      <br/>
      <StdPayment />
    </div>
  );
};

export default Payment;
